interface IProps {}
const IPLoadingModal = (props: IProps) => {
  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: 500,
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
  };

  return (
    <div style={styles} className="d-flex align-items-center">
      {' '}
      <div className="me-2 spinner-border w-15px h-15px"></div> Yükleniyor...
    </div>
  );
};

export default IPLoadingModal;
